import { RacemapColors } from '@racemap/utilities/consts/common';
import type { ThemeConfig } from 'antd';

export type Half = 'start' | 'end';

/** Racemap blue marks the start of a range, violet marks its end. */
export const halfColor: Record<Half, string> = {
  start: RacemapColors.PaleBlue,
  end: RacemapColors.Violet,
};

/** The same pair, as a background tint for the field being edited. */
export const halfTint: Record<Half, string> = {
  start: RacemapColors.LightBlue,
  end: RacemapColors.LightViolet,
};

// Scoped on purpose: the picker follows the half being edited. `colorPrimary` carries the active
// bar and the focus ring, `controlItemBgActive` the selected time cell and the range band.
const themeFor = (half: Half): ThemeConfig => ({
  components: {
    DatePicker: {
      colorPrimary: halfColor[half],
      controlItemBgActive: halfTint[half],
    },
  },
});

export const halfTheme: Record<Half, ThemeConfig> = {
  start: themeFor('start'),
  end: themeFor('end'),
};
